"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NULL_TOPIC = exports.NULL_STAMP = exports.SWARM_GATEWAY_URL = void 0;
exports.SWARM_GATEWAY_URL = 'https://api.gateway.ethswarm.org';
exports.NULL_STAMP = '0000000000000000000000000000000000000000000000000000000000000000';
exports.NULL_TOPIC = '0000000000000000000000000000000000000000000000000000000000000000';
